module.exports = __webpack_public_path__ + "static/media/logolaundry.65c30fbd.jpg";